// Copyright 2018 The Chromium Authors
// Use of this source code is governed by a BSD-style license that can be
// found in the LICENSE file.
import '../shell/shell.js';

import * as Main from '../main/main.js';

new Main.MainImpl.MainImpl();
